import { IconName } from '@billy/design-system'

export const DEFAULT_ITEM_ICON: IconName = 'box'
